// src/admin/api/adminApi.js
//
// Admin / Founder Dashboard API calls ONLY.
// Do not add Operations Dashboard or any other feature's API calls here.
//
// Reuses the project's existing axios instance (with its auth interceptor)
// instead of creating a new axios configuration or hardcoding a token.

import api from '../../api';

/**
 * GET /api/admin/dashboard/
 * GET /api/admin/dashboard/?date=YYYY-MM-DD
 *
 * @param {string} [date] - YYYY-MM-DD. Omit to get the backend's default (today).
 */
export async function getAdminDashboard(date) {
  const params = date ? { date } : undefined;

  const response = await api.get('admin/dashboard/', { params });
  return response.data;
}

/**
 * GET /api/admin/camps/<camp_id>/
 *
 * @param {string|number} campId
 */
export async function getAdminCampDetail(campId) {
  const response = await api.get(`admin/camps/${campId}/`);
  return response.data;
}

/**
 * GET /api/admin/camps/<camp_id>/financial-target/
 *
 * Fallback API for fetching the financial target separately.
 *
 * IMPORTANT:
 * If getAdminCampDetail(campId) already returns:
 *
 * {
 *   financial_target: {...}
 * }
 *
 * then AdminCampDetails.jsx should use that data directly
 * and this function does not need to be called.
 *
 * @param {string|number} campId
 */
export async function getAdminCampFinancialTarget(campId) {
  const response = await api.get(
    `camps/${campId}/financial-target/`
  );

  return response.data;
}

/**
 * PATCH /api/admin/camps/<camp_id>/financial-target/
 *
 * Admin-only financial target configuration update.
 *
 * Percentage target payload:
 * {
 *   contract_value: 50000,
 *   cost_target_type: 'PERCENTAGE',
 *   cost_target_percentage: 30
 * }
 *
 * Amount target payload:
 * {
 *   contract_value: 50000,
 *   cost_target_type: 'AMOUNT',
 *   cost_target_amount: 15000
 * }
 *
 * @param {string|number} campId
 * @param {Object} data
 */
export async function updateAdminCampFinancialTarget(campId, data) {
  const response = await api.patch(
    `camps/${campId}/financial-target/`,
    data
  );

  return response.data;
}